import React  from 'react';
import './App.css';
import PageRoutes from '../src/routes/routes'
function App() {


  return (
    <>
<PageRoutes/>
    </>
  );
}

export default App;
